import React from 'react';

function About() {
  return (
    <>
      <section className="tf-slideshow about-us-page position-relative">
        <div className="banner-wrapper">
          <img className="lazyload" src="images/about/about-banner.png" data-src="images/about/about-banner.png" alt="image-collection" />
          <div className="box-content text-center">
            <div className="container">
              {/* <div className="text text-white"> GENIUS BABY – B2B <br className="d-xl-block d-none" /> Wholesale & Bulk Orders</div> */}
            </div>
          </div>
        </div>
      </section>
      <section className="flat-spacing-9">
        <div className="container">
          <div className="flat-title my-0">
            <span className="title">We are Genius Baby</span>
            <p className="sub-title text_black-2">
              Welcome to GENIUS BABY – B2B | Wholesale & Bulk Orders<br className="d-xl-block d-none" />
              India’s trusted newborn clothing & footwear manufacturer — now open for B2B partnerships! <br className="d-xl-block d-none" />
              At GENIUS BABY, we proudly design and manufacture premium quality clothing and footwear for newborns. <br className="d-xl-block d-none" />
              Whether you're a retailer, distributor, boutique owner, hospital, or gifting company, we have the perfect solution for your bulk needs.
            </p>
          </div>
        </div>
      </section>

      <div class="container"><div class="line"></div></div>

      <section class="flat-spacing-23 flat-image-text-section">
        <div class="container">
          <div className="flat-title lg">
            <span className="title">What We Offer</span>
          </div>
          <div class="tf-grid-layout md-col-2 tf-img-with-text style-4">
            <div class="grid-img-group">
              <div class="tf-image-wrap box-img item-1">
                <div class="img-style">
                  <img class="lazyload" src="images/about/frock.png" data-src="images/about/frock.png" alt="img-slider" />
                </div>
              </div>
              <div class="tf-image-wrap box-img item-2">
                <div class="img-style">
                  <img class="lazyload" src="images/about/cap2.png" data-src="images/about/cap2.png" alt="img-slider" />
                </div>
              </div>
            </div>
            <div class="tf-content-wrap px-0 d-flex justify-content-center w-100">
              <div>
                <div class="heading">Newborn Rompers, Bodysuits <br class="d-xl-block d-none" />
                  Socks, Caps, Booties
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="flat-spacing-15">
        <div class="container">
          <div class="tf-grid-layout md-col-2 tf-img-with-text style-4">
            <div class="tf-content-wrap px-0 d-flex justify-content-center w-100">
              <div>
                <div class="heading">Soft-Sole Baby Footwear</div>
              </div>
            </div>
            <div class="tf-image-wrap">
              <img class="lazyload w-100" data-src="images/about/shoes.png" src="images/about/shoes.png" alt="collection-img" />
            </div>
          </div>
        </div>
      </section>
      <section class="flat-spacing-15">
        <div class="container">
          <div class="tf-grid-layout md-col-2 tf-img-with-text style-4">
            <div class="tf-image-wrap">
              <img class="lazyload w-100" data-src="images/about/capset.png" src="images/about/capset.png" alt="collection-img" />
            </div>
            <div class="tf-content-wrap px-0 d-flex justify-content-center w-100">
              <div>
                <div class="heading">Gift-Ready Packaging</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="flat-spacing-15">
        <div class="container">
          <div class="tf-grid-layout md-col-2 tf-img-with-text style-4">
            <div class="tf-content-wrap px-0 d-flex justify-content-center w-100">
              <div>
                <div class="heading">Seasonal Collections & Custom Designs</div>
              </div>
            </div>
            <div class="tf-image-wrap">
              <img class="lazyload w-100" data-src="images/about/capset.png" src="images/about/capset.png" alt="collection-img" />
            </div>
          </div>
        </div>
      </section>
      <section class="flat-spacing-15">
        <div class="container">
          <div class="tf-grid-layout md-col-2 tf-img-with-text style-4">
            <div class="tf-image-wrap">
              <img class="lazyload w-100" data-src="images/about/capset.png" src="images/about/capset.png" alt="collection-img" />
            </div>
            <div class="tf-content-wrap px-0 d-flex justify-content-center w-100">
              <div>
                <div class="heading">Exclusive Hampers for Hospitals & Events</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container mb-5">
          <div className="bg_grey-2 radius-10 flat-wrap-iconbox">
            <div className="flat-title lg">
              <span className="title fw-5">Why Partner With US?</span>
            </div>
            <div className="flat-iconbox-v3 lg">
              <div className='row'>
                <div className='col-md-4 p-3'>
                  <div className="tf-icon-box text-center">
                    <div className="icon">
                      <i className="icon-materials"></i>
                    </div>
                    <div className="content">
                      <div className="title">Direct Manufacturer Prices</div>
                      <p className="text_black-2">No middlemen, better margins.</p>
                    </div>
                  </div>
                </div>
                <div className='col-md-4 p-3'>
                  <div className="tf-icon-box text-center">
                    <div className="icon">
                      <i className="icon-safe"></i>
                    </div>
                    <div className="content">
                      <div className="title">Certified Safe Fabrics</div>
                      <p className="text_black-2">Hypoallergenic, soft, and baby-safe.</p>
                    </div>
                  </div>
                </div>
                <div className='col-md-4 p-3'>
                  <div className="tf-icon-box text-center">
                    <div className="icon">
                      <i className="icon-shirt"></i>
                    </div>
                    <div className="content">
                      <div className="title">Custom Branding Available</div>
                      <p className="text_black-2">Private label & logo options.</p>
                    </div>
                  </div>
                </div>
                <div className='col-md-4 p-3'>
                  <div className="tf-icon-box text-center">
                    <div className="icon">
                      <i className="icon-heart"></i>
                    </div>
                    <div className="content">
                      <div className="title">Made in India</div>
                      <p className="text_black-2">Proudly crafted at our own facility.</p>
                    </div>
                  </div>
                </div>
                <div className='col-md-4 p-3'>
                  <div className="tf-icon-box text-center">
                    <div className="icon">
                      <i className="icon-place"></i>
                    </div>
                    <div className="content">
                      <div className="title">Pan-India Delivery</div>
                      <p className="text_black-2">Reliable and timely bulk shipping.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


    </>
  )
}

export default About;